import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/backdrop.css';
import 'tippy.js/themes/light.css';
import 'tippy.js/animations/shift-toward.css';
import 'tippy.js/animations/shift-toward-subtle.css';
import 'tippy.js/animations/shift-toward-extreme.css';

export class StatsCard extends Component {
  render() {
    return (
      <div className="card card-stats">
        <div className="content">
          <Row>
            <Row>
              <Col xs={1}>
                <div>
                  <Tippy interactive = {true} offset={[60, 20]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                    <h5 style={{height:'34px', width:'15rem', fontSize:"13px"}}>Inventory will be loaded based on the selected locations only</h5>
                  </div>}>
                    {this.props.infoIcon}
                  </Tippy>
                </div>
              </Col>
            </Row>
            <Col xs={4}>
            {this.props.elements ?
              <div style={{marginTop:"-17px"}} className="fa-3x text-center icon-warning">
                {this.props.bigIcon}
              </div> 
              : 
              <div style={{marginTop:"-7px"}} className="fa-3x text-center icon-warning">
              {this.props.bigIcon}
            </div>}
            </Col>
            <Col xs={7}>
              {this.props.elements ? 
              <div className="number">
                <p style={{'font-weight': 'bold', marginLeft:'-4px'}}>{this.props.statsText}</p>
              <h4 className='values'>{this.props.statsValue}</h4>
              </div>
               : 
               <div className="numbers">
                <p style={{'font-weight': 'bold'}}>{this.props.statsText}</p>
                <h4 className='value'>{this.props.statsValue}</h4>
              </div>
              }
            </Col>
          </Row>
          <div className="footer">
          {/* <hr />
            <div className="stats">
              {this.props.statsIcon} {this.props.statsIconText}
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default StatsCard;